// Format currency for display
export const formatCurrency = (value: string) => {
    if (!value) return "-";
    const number = parseFloat(value);
    return `R$ ${number.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`;
};